"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";

const SESSION_KEY = "seoh:site-feedback:enabled";

/** Opt-in reviewer tooling; no assets or microphone request on ordinary visits. */
export default function SiteFeedbackGate() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const documentUrl = useRef<URL | null>(null);
  const started = useRef(false);

  useEffect(() => {
    const current = new URL(window.location.href);
    documentUrl.current ??= current;
    const requested = current.searchParams.get("feedback");
    let remembered = false;
    try {
      remembered = sessionStorage.getItem(SESSION_KEY) === "1";
      if (requested !== null) {
        if (requested === "1") sessionStorage.setItem(SESSION_KEY, "1");
        else sessionStorage.removeItem(SESSION_KEY);
      }
    } catch {
      // Explicit URLs and decorated links still work without browser storage.
    }
    const enabled = requested === "1" || (requested === null && remembered);
    if (!enabled) {
      if (started.current) window.location.reload();
      return;
    }

    // The shared panel owns a document's listeners and anchors. Start each new
    // page in a fresh document, with its query-scoped microphone policy intact.
    if (
      requested !== "1" ||
      current.pathname !== documentUrl.current.pathname ||
      documentUrl.current.searchParams.get("feedback") !== "1"
    ) {
      current.searchParams.set("feedback", "1");
      window.location.replace(current.href);
      return;
    }
    if (started.current) return;
    started.current = true;
    if (!document.getElementById("site-feedback-boot")) {
      const script = document.createElement("script");
      script.id = "site-feedback-boot";
      script.src = "/site-feedback/boot.js";
      document.body.append(script);
    }
  }, [pathname, searchParams]);

  return null;
}
